import React from 'react'
import { Link } from 'react-router-dom'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer
      className="mt-auto shrink-0 bg-footer text-white px-6 py-12"
      role="contentinfo"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-10 md:flex-row md:items-center md:justify-between md:gap-12">
        <div className="flex justify-center md:justify-start md:max-w-[min(100%,20rem)]">
          <Link to="/" className="block">
            <img
              src="/syentist_logo_landscape.png"
              alt="Syentist Lab"
              className="h-10 w-auto max-w-[min(280px,100%)] object-contain object-center md:h-11"
              loading="lazy"
            />
          </Link>
        </div>

        <div className="flex flex-col items-center gap-6 text-center text-sm md:items-end md:text-right md:gap-5">
          <p className="max-w-xl text-gray-300 leading-relaxed">
            © {currentYear} Syentist Lab Inc. All rights reserved.
          </p>
          <nav className="flex flex-wrap justify-center items-center gap-x-8 gap-y-3 md:justify-end font-medium tracking-tight text-white">
            <a
              href="https://www.linkedin.com/company/syentist"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 underline-offset-4 hover:text-white/95 hover:underline decoration-white/70"
              aria-label="Syentist on LinkedIn"
            >
              <svg
                className="h-[1.125rem] w-[1.125rem] shrink-0"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
              LinkedIn
            </a>
            <Link to="/privacy-policy" className="underline-offset-4 hover:underline decoration-white/70">
              Privacy Policy
            </Link>
            <Link to="/terms" className="underline-offset-4 hover:underline decoration-white/70">
              Terms &amp; Conditions
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  )
}

export default Footer
